import { useHead } from "@vueuse/head";

const SITE_NAME = "goplayTv";
// Non-www is the canonical host (the server 301-redirects www -> non-www).
const SITE_URL  = "https://goplaytv.live";
const DEFAULT_IMG = `${SITE_URL}/img/og-default.jpg`;

interface SeoOptions {
  title: string;
  description: string;
  image?: string;
  url?: string;
  keywords?: string;
}

export function useSeo(opts: SeoOptions) {
  const title       = `${opts.title} | ${SITE_NAME}`;
  const description = opts.description;
  const image       = opts.image || DEFAULT_IMG;
  const url         = opts.url ? `${SITE_URL}${opts.url}` : SITE_URL;
  const keywords    = opts.keywords || "IPTV, live TV streaming, sports channels, HD IPTV subscription";

  useHead({
    title,
    meta: [
      { name: "description",        content: description },
      { name: "keywords",           content: keywords },
      { name: "robots",             content: "index, follow" },

      // Open Graph
      { property: "og:type",        content: "website" },
      { property: "og:site_name",   content: SITE_NAME },
      { property: "og:title",       content: title },
      { property: "og:description", content: description },
      { property: "og:image",       content: image },
      { property: "og:url",         content: url },

      // Twitter Card
      { name: "twitter:card",        content: "summary_large_image" },
      { name: "twitter:title",       content: title },
      { name: "twitter:description", content: description },
      { name: "twitter:image",       content: image },
    ],
    link: [
      { rel: "canonical", href: url },
    ],
  });
}
